import enUS from './en-US';
import th from './th';

// object that contains localization string, outer key is locale key (e.g. 'en', 'th')
export default {
  'en-US': enUS,
  th: th,
};
